/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseClearChatMemoryResult } from '../../models/api-response-clear-chat-memory-result';
import { ClearChatMemoryRequest } from '../../models/clear-chat-memory-request';

export interface ClearChatMemory$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: ClearChatMemoryRequest
}

export function clearChatMemory(http: HttpClient, rootUrl: string, params: ClearChatMemory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseClearChatMemoryResult>> {
  const rb = new RequestBuilder(rootUrl, clearChatMemory.PATH, 'delete');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseClearChatMemoryResult>;
    })
  );
}

clearChatMemory.PATH = '/api/ai-assistant/chat-memory';
